import React from "react"

import Layout from "../components/layout/layout"
import SEO from "../components/seo"
import HomepageImageGallery from "../components/homepage-image-gallery/homepage-image-gallery";
import BecomeMember from "../components/become-member/become-member";
import HomepageHero from "../components/homepage-hero/homepage-hero";
import NewsPreview from "../components/news-preview/news-preview";
import EventPreview from "../components/event-preview/event-preview";
import {graphql} from "gatsby";
import {filterTermine} from "../util/filterTermine";

const IndexPage = ({data}) => {
    return (
    <Layout>
        <SEO title="Start"/>
        <HomepageHero></HomepageHero>
        <div className="container">

            <div className="grid">
                <div className="col-6 col-12td col-12md col-12smd padding">
                    <div className="section">

                        <h1 className={'title'}>AKtuelles</h1>
                        <h4 className={'subtitle'}>Aktuelle Mitteilungen
                        </h4>
                        <NewsPreview node={data.blog.edges[0].node}></NewsPreview>
                    </div>
                </div>
                <div className="col-6 col-12td col-12md col-12smd padding">
                    <div className="section">

                        <h1 className={'title'}>Termine</h1>
                        <h4 className={'subtitle'}>Aktuelle Termine und Veranstaltungen
                        </h4>
                        {
                            data.events.edges.filter(filterTermine).map((item, i) => (
                                <EventPreview key={i} node={item.node}></EventPreview>
                            ))
                        }

                    </div>

                </div>
            </div>
        </div>
        <BecomeMember></BecomeMember>
        <HomepageImageGallery images={data.images}></HomepageImageGallery>
    </Layout>
);
}

export const pageQuery = graphql`
    query IndexQuery {
      blog: allMarkdownRemark(
        filter: {fileAbsolutePath: {regex: "//blog//"}}
        sort: { order: DESC, fields: [frontmatter___date] }
        limit: 1
      ) {
        edges {
          node {
            rawMarkdownBody
            fileAbsolutePath
            frontmatter {
              date
              title
              subtitle
              thumbnail              
            }
          }
        }
      }
      events: allMarkdownRemark(
        filter: {fileAbsolutePath: {regex: "//events//"}}
        sort: { order: DESC, fields: [frontmatter___date] }
        limit: 3
      ) {
        edges {
          node {
            rawMarkdownBody
            fileAbsolutePath
            frontmatter {
              title
              time
              location
              hidden
            }
          }
        }
      }
      
      images: allMarkdownRemark(
        filter: {fileAbsolutePath: {regex: "//blog//"}}
        sort: { order: DESC, fields: [frontmatter___date] }
        limit: 1000
      ) {
        edges {
          node {
          fileAbsolutePath
            frontmatter {
              galleryImages
              thumbnail
              title
            }
          }
        }
      }
    }
  `;

export default IndexPage
